import { useState, useCallback } from 'react';
import { getAllEmployees } from 'Api/apiService';
import { SbNotification } from 'uiCore';
import {
  EMPLOYEE_PAGE_SIZE,
  ERROR_MESSAGES,
  WARNING_TITLES,
  getApiErrorMessage,
} from 'constants/employeeManagement.constants';

const useEmployees = () => {
  const [employees, setEmployees] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    pageSize: EMPLOYEE_PAGE_SIZE,
    totalRecords: 0,
  });
  const [loading, setLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState('all');

  const fetchPage = useCallback(
    async ({ pageNo, pageSize, complete } = {}) => {
      setLoading(true);
      try {
        const response = await getAllEmployees({
          pageNo: pageNo ?? pagination.currentPage,
          totalRecordsPerPage: pageSize ?? pagination.pageSize,
          complete: complete ?? statusFilter,
        });

        if (response?.error || response?.error_code) {
          SbNotification.warning(WARNING_TITLES.FETCH_EMPLOYEES, ERROR_MESSAGES.FETCH_EMPLOYEES_FAILED, { key: 'employee-fetch-warning' });
          return;
        }
        if (response) {
          setEmployees(response.data || []);
          setPagination(
            response.pagination || {
              currentPage: pageNo ?? 1,
              totalPages: 1,
              pageSize: pageSize ?? EMPLOYEE_PAGE_SIZE,
              totalRecords: 0,
            },
          );
        }
      } catch (error) {
        SbNotification.warning(WARNING_TITLES.FETCH_EMPLOYEES, ERROR_MESSAGES.FETCH_EMPLOYEES_FAILED);
      } finally {
        setLoading(false);
      }
    },
    [pagination.currentPage, pagination.pageSize, statusFilter],
  );

  const changeStatusFilter = useCallback(
    (value) => {
      setStatusFilter(value);
      fetchPage({ pageNo: 1, complete: value });
    },
    [fetchPage],
  );

  return {
    employees,
    pagination,
    loading,
    statusFilter,
    fetchPage,
    changeStatusFilter,
  };
};

export default useEmployees;
